<template>
  <div> <!-- Only one element for Transition -->
    <div class="row">
      <div class="col-12">
        <SelectInputComponent
          v-model="roomsCount"
          label="Nombre de chambre(s)"
          placeholder="Nombre de chambre(s)"
          :options="Array.from({ length: 11 }, (_, i) => ({ value: i, label: i.toString(), selected: roomsCount === i }))"
          :required="true"
          class="mb-3 col-12 col-md-6 mx-auto"
        />
        <div class="text-center">
          <small class="text-muted">
            <i class="fa-solid fa-info-circle me-1"></i>
            Indiquez le nombre de chambres que vous souhaitez réserver.
          </small>
        </div>
      </div>
    </div>

    <template v-if="roomsFields.length > 0">
      <div v-for="(room, index) in roomsFields" :key="room.key" class="card mt-3">
        <div class="card-header d-flex justify-content-between align-items-center mb-3">
          <h5 class="mb-0">
            <i class="fa-solid fa-bed me-2"></i>
            Chambre {{ index + 1 }}
          </h5>
        </div>
        <div class="card-body pt-0">
          <template v-if="getAvailableHotelTypes().size > 0">
            <div class="row">
              <CheckboxButtonComponent
                :value-key="`hotelRooms[${index}].type`"
                :required="true"
                :options="Array.from(getAvailableHotelTypes()).map(type => ({ value: type, label: GetHotelRoomTypeLabelLong(type) }))"
                @change="() => onRoomTypeChange(room.value)"
                class="text-center mb-2 col-12 col-md-10 mx-auto"
              />
              <template v-if="room.value.type == TravelDbHotelRoomTypeEnum.Twin">
                 <div class="col-12">
                    <SelectInputComponent
                      :value-key="`hotelRooms[${index}].roommates[0]`"
                      :options="[<UserParticipationHotelRoommate>
                          {
                            userId: userStore.currentUser!.id,
                            firstName: userStore.currentUser!.firstName,
                            lastName: userStore.currentUser!.lastName?.toUpperCase()
                          }].concat((participation?.companions??[]).map(comp => (<UserParticipationHotelRoommate>
                          {
                            companionId: comp.id,
                            firstName: comp.firstName,
                            lastName: comp.lastName?.toUpperCase()
                          })) || [])"
                      :value-retriever="(item: UserParticipationHotelRoommate) => `${item.userId??''}#${item.companionId??''}`.toString()"
                      :label-retriever="(item: UserParticipationHotelRoommate) => `${item.lastName?.toUpperCase()} ${item.firstName}`"
                      :disabled-retriever="(item: UserParticipationHotelRoommate) => alreadySelected(index,0,item).value.includes(item.userId??item.companionId)"
                      empty-option-label=" "
                      :empty-option-value="null"
                      label="Qui sera présent dans cette chambre ?"
                      placeholder="Qui sera présent dans cette chambre ?"
                      :required="false"
                      class="mb-3"
                    />
                  </div>
                <!-- </div> -->
                <div class="col-12">
                  <AutocompleteComponent
                    :value-key="`hotelRooms[${index}].roommates[1]`"
                    label="Je souhaite partager ma chambre avec"
                    :placeholder="`Selectionnez un ${GetCompanionLabel(participation?.travel.companionLabel)} ou entrez le nom d'un autre participant`"
                    selectLabel="Selectionner"
                    noElementFoundText="Aucun participant trouvé"
                    @search-change="searchParticipantChange"
                    :options="participantsToAddList"
                    options-track-by="customId"
                    :options-label-function="(obj) => `${obj.lastName?.toUpperCase()} ${obj.firstName}`"
                    :required="false"
                    :hide-selected="false"
                    :allow-clear="true"
                    class="mb-3"
                  />
                </div>
              </template>
              <template v-else-if="participation?.companions && participation.companions.length > 0">
                <div class="text-center my-2">Veuillez indiquer les personnes dans cette chambre</div>
                <div v-for="roomMateIdx in (room.value.type == TravelDbHotelRoomTypeEnum.Famille ? 4 : (room.value.type == TravelDbHotelRoomTypeEnum.Single ? 1 : 2))" :key="roomMateIdx" class="d-flex gap-2">
                  <div class="col-12">
                    <SelectInputComponent
                      :value-key="`hotelRooms[${index}].roommates[${roomMateIdx-1}]`"
                      :options="[<UserParticipationHotelRoommate>
                          {
                            userId: userStore.currentUser!.id,
                            firstName: userStore.currentUser!.firstName,
                            lastName: userStore.currentUser!.lastName?.toUpperCase()
                          }].concat(participation.companions.map(comp => <UserParticipationHotelRoommate>
                          {
                            companionId: comp.id,
                            firstName: comp.firstName,
                            lastName: comp.lastName?.toUpperCase()
                          }) || [])"
                      :value-retriever="(item: UserParticipationHotelRoommate) => `${item.userId??''}#${item.companionId??''}`.toString()"
                      :label-retriever="(item: UserParticipationHotelRoommate) => `${item.lastName?.toUpperCase()} ${item.firstName}`"
                      :disabled-retriever="(item: UserParticipationHotelRoommate) => alreadySelected(index,roomMateIdx-1,item).value.includes(item.userId??item.companionId)"
                      empty-option-label=" "
                      :empty-option-value="null"
                      label="Qui sera présent dans cette chambre ?"
                      placeholder="Qui sera présent dans cette chambre ?"
                      :required="false"
                      class="mb-3"
                    />
                  </div>
                </div>
              </template>
              <div class="d-flex flex-column flex-md-row mt-3"
                v-for="(hotel, hotelIdx) in getAvailableHotels(room.value.type)"
                :key="hotel.id"
              >
                <div class="d-flex flex-column w-100">
                  <div
                    v-for="(hotelroom,hotelroomIdx) in getAvailableHotelRooms(hotel, room.value.type)"
                    :key="hotelroom.id"
                    @mouseenter="onHoverRoom(index, hotelIdx, hotelroom)"
                    @mouseleave="onLeaveRoom(index, hotel, hotelIdx,room.value.roomId)"
                  >
                    <input type="radio"
                      class="btn-check"
                      :name="`hotelRooms-${index}`"
                      :value="hotelroom.id"
                      v-model="room.value.roomId"
                      :id="`hotelRooms-${index}-${hotelIdx}-${hotelroomIdx}`"
                      :disabled="hotelroom.quotaLeft != null && hotelroom.quotaLeft <= 0"
                    >
                    <label
                      :for="`hotelRooms-${index}-${hotelIdx}-${hotelroomIdx}`"
                      class="btn d-flex flex-wrap justify-content-between mb-2 hotelRoomLabel"
                      :class="[room.value.roomId == hotelroom.id ? 'btn-outline-primary': 'btn-outline-secondary']"
                    >
                      <div class="d-flex flex-column align-items-start">
                        <span class="fw-bold text-capitalize text-start" v-html="formatNameToHtml(hotelroom.name)"></span>
                        <small
                          v-if="isLowRoomQuota(hotelroom)"
                          :class="{ 'text-danger fst-italic': isLowRoomQuota(hotelroom), 'fw-semibold' : hotelroom.quotaLeft == 0 }"
                          style="font-size: .7em;"
                        >
                          {{ getRoomQuotaLabel(hotelroom) }}
                        </small>
                        <small v-else-if="hotelroom.quotaLeft != null" class="pt-2 text-end">Quota chambres restantes <span class="border border rounded py-1 px-2 ms-2">{{ hotelroom.quotaLeft }}</span></small>

                        <!-- <div v-if="hotelroom.quotaLeft != null && hotelroom.quotaLeft <= 0" class="text-danger fw-semibold pull-right">Epuisé</div> -->
                      </div>
                      <small class="text-nowrap" v-if="hotelroom.onRequest === true">Selon disponibilité</small>
                      <small class="text-nowrap" v-else-if="hotelroom.price === 0">Inclus</small>
                      <small class="text-nowrap" v-else>( {{ formatPrice(hotelroom.price * ((participation?.travel.nights??0) + (participation?.travelInfo.extraNights??0))) }} / pers. )</small>

                    </label>
                  </div>
                </div>
                <div class="align-self-end col-12 col-md-4 me-md-2 position-relative overflow-hidden rounded-3 h-100 ms-3 mb-3 mb-md-0" style="min-height:150px; max-height: 15vh;">
                  <img
                    :ref="(el) => (roomPicturesRef[index]??=[])[hotelIdx] = el"
                    :src="getHotelRoomPicture(hotel, room.value.roomId)" class="w-100 h-100 object-fit-cover position-md-absolute">
                  <div class="position-absolute bottom-0 start-0 w-100 mh-100 p-3 pe-1 text-white" style="background:linear-gradient(transparent, rgba(0,0,0,0.8));">
                    <h5 class="mb-0 fw-bold">{{ hotel.name }}</h5>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </template>

    <PageBottomMessage message-key="pageHotels"></PageBottomMessage>

  </div>
</template>
<script setup lang="ts">
import { ref,computed,onMounted } from 'vue';
import { useFieldArray } from 'vee-validate';
import genericHotelImage from '@/assets/generic-hotel.jpg'

import { GetCompanionLabel, GetHotelRoomTypeLabelLong, getPictureUrl, formatPrice, formatNameToHtml } from '@/compositions/helper';
import travelApi from '@/api/travelApi';
import { useNotificationsStore } from '@/stores/notificationStore';
import { useUserStore } from '@/stores/userStore';

const notificationsStore = useNotificationsStore();
const userStore = useUserStore();

const participation = defineModel<UserParticipation>();
const roomsCountRef = ref<number>(0);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const roomPicturesRef = ref<Record<number, Record<number, any>>>({});
const participantsToAddList = ref<UserParticipationHotelRoommate[]>([]);

const roomsCount = computed<number>({
  get: () => roomsCountRef.value,
  set: (value: number) => {
    updateRoomsCount(value);
    roomsCountRef.value = value;
  }
});

const getHotelRoomPicture = (hotel:UserHotel, selectedRoomId:number) => {
  const selectedRoomPictureKey = hotel.rooms?.find(room => room.id === selectedRoomId)?.picture?.key;
  if(selectedRoomPictureKey) {
    return getPictureUrl(selectedRoomPictureKey,150);
  } else {
  return hotel.picture?.key ? getPictureUrl(hotel.picture.key,150) : genericHotelImage;
  }
};

const onHoverRoom = (idx:number, hotelIdx:number, room:UserHotelRoom) => {
  if(room.picture?.key && roomPicturesRef.value[idx] && roomPicturesRef.value[idx][hotelIdx]) {
    roomPicturesRef.value[idx][hotelIdx].src = getPictureUrl(room.picture?.key,150);
  }
};

const onLeaveRoom = (idx:number, hotel:UserHotel, hotelIdx:number, selectedRoomId:number) => {
  if(roomPicturesRef.value[idx] && roomPicturesRef.value[idx][hotelIdx]) {
    const selectedRoomPictureKey = hotel.rooms?.find(room => room.id === selectedRoomId)?.picture?.key;

    if(selectedRoomPictureKey) {
      roomPicturesRef.value[idx][hotelIdx].src = getPictureUrl(selectedRoomPictureKey,150);
    } else {
      roomPicturesRef.value[idx][hotelIdx].src = hotel.picture?.key ? getPictureUrl(hotel.picture.key,150) : genericHotelImage;
    }
  }
};

const getAvailableHotelTypes = () => {
  return participation.value?.travel.hotels?.reduce((types:Set<TravelDbHotelRoomTypeEnum>, hotel: UserHotel) => {
    hotel.rooms?.forEach((room) => {
      types.add(room.type);
    });
    if((participation.value?.companions?.length ?? 0) < 1) {
      types.delete(TravelDbHotelRoomTypeEnum.Double);
    }
    if((participation.value?.companions?.length ?? 0) < 2) {
      types.delete(TravelDbHotelRoomTypeEnum.Famille);
    }
    return types;
  }, new Set<TravelDbHotelRoomTypeEnum>()) || new Set<TravelDbHotelRoomTypeEnum>();
}

const getAvailableHotels = (roomType:TravelDbHotelRoomTypeEnum) => {
  return participation?.value?.travel.hotels?.filter(
         hotel => hotel.rooms
      && hotel.rooms.length > 0
      && hotel.rooms.some((room: UserHotelRoom) => room.type === roomType)
     ) || [];
};

const getAvailableHotelRooms = (hotel:UserHotel, roomType:TravelDbHotelRoomTypeEnum) => {
  return hotel?.rooms?.filter((room: UserHotelRoom) => room.type === roomType) || [];
};

const isLowRoomQuota = (room: UserHotelRoom): boolean => {
  return room.quotaLeft != null && (room.quotaLeft <= 5);
};

const getRoomQuotaLabel = (room: UserHotelRoom): string => {
  if(room.quotaLeft == null) {
    return '';
  }

  const chambreLabel = room.quotaLeft > 1 ? 'chambres' : 'chambre';

  if(room.quotaLeft <= 0) {
    return 'Epuisé';
  }
  else if (room.quotaLeft === 1) {
    return 'Plus qu\'une chambre disponible';
  }
  else if (room.quotaLeft <= 5) {
    return `Plus que ${room.quotaLeft} ${chambreLabel} disponibles`;
  }
  else return '';
};

const alreadySelectedCurrentUser = computed(() => roomsFields.value
  .flatMap(room => room.value.roommates || [])
  .filter(rm => rm?.userId)
  .map(rm => rm?.userId)
  .includes(userStore.currentUser!.id)
);

const alreadySelectedCompanion = (currentRoomIndex: number, currentRoommateIndex?: number) => computed(() =>
  roomsFields.value
    .flatMap((room, i) => (
      i !== currentRoomIndex
      ? room.value.roommates
      : room.value.roommates?.filter((_, idx) => idx !== currentRoommateIndex)
    ) || [])
    .filter(rm => rm?.companionId != null)
    .map(rm => rm?.companionId)
)

const alreadySelectedParticipant = (currentRoomIndex: number, currentRoommateIndex?: number) => computed(() =>
  roomsFields.value
    .flatMap((room, i) => (
      i !== currentRoomIndex
      ? room.value.roommates
      : room.value.roommates?.filter((_, idx) => idx !== currentRoommateIndex)
    ) || [])
    .filter(rm => rm?.userId != null)
    .map(rm => rm?.userId)
)

const alreadySelected = (currentRoomIndex: number, currentRoommateIndex: number, currentRoommate: UserParticipationHotelRoommate) => computed(() => {
  if (currentRoommate.companionId != null){
    return alreadySelectedCompanion(currentRoomIndex, currentRoommateIndex).value;
  } else {
    return alreadySelectedParticipant(currentRoomIndex, currentRoommateIndex).value;
  }
})


const searchParticipantChange = (query: string) => {
  const myCompanions = participation.value?.companions?.map(comp => <UserParticipationHotelRoommate>
        {
          customId: `#${comp.id}`,
          companionId: comp.id,
          firstName: comp.firstName,
          lastName: comp.lastName?.toUpperCase()
        }).sort((a, b) => a.lastName?.localeCompare(b.lastName || '') || 0) || [];

  if (query.length < 1) {
    participantsToAddList.value = myCompanions;
    return;
  }
  if (participation.value?.travel.id) {
    travelApi.searchTravelParticipants(participation.value.travel.id, query).then((response) => {
      participantsToAddList.value = myCompanions.concat(response.data.map(part => <UserParticipationHotelRoommate>
        {
          customId: `${part.id}#`,
          userId: part.id,
          firstName: part.firstName,
          lastName: part.lastName?.toUpperCase()
        }).sort((a, b) => a.lastName?.localeCompare(b.lastName || '') || 0));
    }).catch((error: Error) => {
      notificationsStore.notifyError("Erreur lors de la recherche des participants.", error.message);
    });
  }
};

const { remove: removeRoom, push: pushRoom, fields: roomsFields } = useFieldArray<UserParticipationHotelRoom>(() => "hotelRooms");

const defaultRoomType = computed(() => {
  if(((participation?.value?.companions?.length??0) == 0) && (participation?.value?.travel.hotels?.some(hotel => hotel.rooms?.some(room => room.type === TravelDbHotelRoomTypeEnum.Single)))) {
    return TravelDbHotelRoomTypeEnum.Single;
  } else if(((participation?.value?.companions?.length??0) == 0) && (participation?.value?.travel.hotels?.some(hotel => hotel.rooms?.some(room => room.type === TravelDbHotelRoomTypeEnum.Twin)))) {
    return TravelDbHotelRoomTypeEnum.Twin;
  } else if(participation?.value?.travel?.hotels?.some(hotel => hotel.rooms?.some(room => room.type === TravelDbHotelRoomTypeEnum.Double))) {
    return TravelDbHotelRoomTypeEnum.Double;
  } else if(participation?.value?.travel?.hotels?.some(hotel => hotel.rooms?.some(room => room.type === TravelDbHotelRoomTypeEnum.Twin))) {
    return TravelDbHotelRoomTypeEnum.Twin;
  } else if(participation?.value?.travel?.hotels?.some(hotel => hotel.rooms?.some(room => room.type === TravelDbHotelRoomTypeEnum.Single))) {
    return TravelDbHotelRoomTypeEnum.Single;
  } else {
    return TravelDbHotelRoomTypeEnum.Double;
  }
});

const defaultRoomIdByType = (type: TravelDbHotelRoomTypeEnum) => {
  const hotel = participation?.value?.travel.hotels?.find(hotel => hotel.rooms?.some(room => room.type === type));
  return hotel?.rooms?.find(room => room.type === type)?.id || 0;
};

// Créer une nouvelle chambre
const createNewRoom = (): UserParticipationHotelRoom => ({
  id: 0,
  type: defaultRoomType.value,
  roommates: [],
  roomId: defaultRoomIdByType(defaultRoomType.value),
  rank: (participation.value?.hotelRooms?.length ?? 0) + 1
});

const onRoomTypeChange = (room: UserParticipationHotelRoom) => {
  room.roommates = [];
  if(room.type == TravelDbHotelRoomTypeEnum.Single && !alreadySelectedCurrentUser.value) {
    room.roommates = [{
      userId: userStore.currentUser!.id,
      firstName: userStore.currentUser !.firstName,
      lastName: userStore.currentUser!.lastName?.toUpperCase()
    }];
  } else if (room.type == TravelDbHotelRoomTypeEnum.Twin) {
    room.roommates = [{
      userId: userStore.currentUser!.id,
      firstName: userStore.currentUser !.firstName,
      lastName: userStore.currentUser!.lastName?.toUpperCase()
    }];
  } else if (room.type == TravelDbHotelRoomTypeEnum.Double && !alreadySelectedCurrentUser.value) {
    room.roommates = [{
      userId: userStore.currentUser!.id,
      firstName: userStore.currentUser !.firstName,
      lastName: userStore.currentUser!.lastName?.toUpperCase()
    }];
  }

  room.roomId = defaultRoomIdByType(room.type);
}

// Mettre à jour le nombre de chambres
const updateRoomsCount = (value: number | undefined) => {
  const count = Math.max(Math.min(Number(value) || 0, 10), 0);

  if (count > roomsFields.value.length) {
    // Ajouter des chambres
    const toAdd = count - roomsFields.value.length;
    for (let i = 0; i < toAdd; i++) {
      const newRoom = createNewRoom();
      onRoomTypeChange(newRoom);
      pushRoom(newRoom);
    }
  } else if (count < roomsFields.value.length) {
    // Supprimer des chambres
    const toRemove = roomsFields.value.length - count;
    for (let i = 0; i < toRemove; i++) {
      removeRoom(roomsFields.value.length - 1);
    }
  }
};

// Initialiser au montage
onMounted(() => {
  if (roomsFields.value) {
    roomsCount.value = roomsFields.value.length;
  }
  if (roomsCount.value == 0) {
    roomsCount.value = 1;
    updateRoomsCount(1);
  }
});
</script>
<style scoped>
  .hotelRoomLabel.btn-outline-secondary:hover {
    transform: scale(1.02);
    border-color: var(--bs-primary);
    color: var(--bs-primary);
  }
</style>
